var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-container",attrs:{"id":"app"}},[_c('Header',{attrs:{"current-locale":_vm.locale},on:{"toggle-language":_vm.toggleLanguage}}),_c('router-view'),_c('Footer',{attrs:{"locale":_vm.locale}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }